import React from "react";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import contactCover from "../../resources/projectUrbanica/1.jpg";
const Career = () => {
  return (
    <motion.div
      className="dark:bg-slate-600"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    >
      {/* Hero section  */}
      <div className="group relative ">
        <img
          className="h-64 w-full object-cover grayscale  lg:h-[550px]"
          src={contactCover}
          alt="..."
        />
        {/* <div className="absolute left-0 flex flex-col items-center justify-center w-full h-0 duration-500 bg-indigo-700  top-36 lg:top-60">
          <h1 className="text-3xl text-white lg:text-6xl">Career</h1>
          <h1 className="text-xl text-white ">Join the Brownearth Family</h1>
        </div> */}
      </div>

      {/* Our Mission section  */}
      <div className="m-10 lg:mx-20 2xl:mx-36">
        <div className="my-6 flex flex-col gap-4">
          <span className="text-2xl text-stone-600 dark:text-slate-200 lg:text-4xl">
            Open Positions
          </span>
          <div className="text-lg dark:text-slate-200">
            <div>
              {" "}
              Sorry, there are no Job opportunities currently in Brownearth
              Developments Ltd.
            </div>
            <div className="text-sm dark:text-slate-200">
              We request you to check back again or upload your resume so that
              we can get back to you whenever there is a suitable opportunity.
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div>To submit your resume for future reference</div>
            <div>
              {" "}
              <Link
                to="/contact"
                className="rounded-md border-2 border-black bg-black p-2 text-white duration-300 hover:bg-white hover:text-black"
                aria-current="page"
              >
                Click Here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Career;
